import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Stale-while-revalidate cache. Surfaces cached content instantly
// (no flash of empty state), but always re-fetches on every mount so
// admin edits propagate without a hard refresh.
let _cache = null;
let _inflight = null;
const _listeners = new Set();

function broadcast() {
  for (const l of _listeners) l(_cache);
}

function revalidate() {
  if (_inflight) return _inflight;
  _inflight = axios
    .get(`${API}/site/content`, {
      // Belt-and-braces: tell the browser not to cache this JSON.
      headers: { "Cache-Control": "no-cache" },
    })
    .then(({ data }) => {
      _cache = data || {};
      broadcast();
    })
    .catch(() => {
      if (!_cache) {
        _cache = {};
        broadcast();
      }
    })
    .finally(() => {
      _inflight = null;
    });
  return _inflight;
}

export function useSiteContent() {
  const [content, setContent] = useState(_cache);

  useEffect(() => {
    _listeners.add(setContent);
    if (_cache) setContent(_cache);
    // Always revalidate, even if cache present.
    revalidate();
    return () => {
      _listeners.delete(setContent);
    };
  }, []);

  return content || {};
}

// Allow other surfaces (admin save) to push an updated cache.
export function setSiteContentCache(next) {
  _cache = next || {};
  broadcast();
}
